if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

      // To use in custom drawers
      setTimeout(() => {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }, 50)
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

          if ( $Cart.state.settings.isEnabled ) {
              $Cart.get().then(cart => {
                  window.$Cart.toggleDrawer(true)
              })
              return
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/*
document.addEventListener('DOMContentLoaded', (evt) => {
    const [...allInputs] = document.querySelectorAll('.product__info-container input')
    let colorInputs = []
    if (!allInputs) return
    colorInputs = allInputs.filter(input => input.name == 'Color')
    const sizefieldset = [...document.querySelectorAll('.product__info-container input')].find(input => input.name == 'Size').parentElement
    colorInputs.forEach(input => {
        input.addEventListener('click',() => {
            variantsDisabler(input, sizefieldset)
        });
    })
    variantsDisabler(colorInputs.find(input => input.checked ), sizefieldset)

    function variantsDisabler(input, sizefieldset) {
        let metafieldSizeHidden = input.dataset.size
        let metafieldSizeHiddenArray = ''
        if(metafieldSizeHidden) metafieldSizeHiddenArray = metafieldSizeHidden.split(',')
        let availableVariants = [...$Product.state.product.variants].filter(variant => variant.option1 == `${input.value}` && variant.inventory_quantity > 0).map(variant => variant.option2);
        [...sizefieldset.querySelectorAll('input')].forEach( size => availableVariants.includes(`${size.value}`) && !metafieldSizeHiddenArray.includes(`${size.value}`) ? size.removeAttribute('disabled') : size.setAttribute('disabled', ''));
    }
})

document.addEventListener('click', (evt) => {
    if(evt.target.closest('.swatch--color')) {
        setTimeout(() => {
            const [...elemSizes] = document.querySelectorAll('.product__info-container [data-size] input')
            const clickSize = elemSizes.filter(x => !x.disabled)
            if (clickSize.length > 0) clickSize[0].click()
        }, 1000);
    }
})
*/
